import styled from 'styled-components'

export const Wrapper = styled.div ` 
    padding: 20px 150px;
    color: #999;
    display: flex;
    flex-direction: column;
    
    h1{
        align-self: center;
        font-size: 40px;
        color: #F77B57;
    }

    span{
        display: flex;
        flex-direction: column;
        padding-top: 30px;
        text-indent: 40px;
        font-size: 20px;

    }
`
